// CardHeaderAction.tsx

import { Box, Stack } from '@mui/material'
import React, { PropsWithChildren } from 'react'

export interface ICardHeaderProps {
  title?: string
  tooltip?: string
}

export default function CardHeaderActions({ children }: PropsWithChildren<ICardHeaderProps>) {
  return (
    <Box>
      <Stack direction="row" spacing={2}>
        {children}
      </Stack>
    </Box>
  )
}
